<div id="overlay" *ngIf="1==1" >
          <div id="loading-center">
              <div id="loading-center-absolute">
                  <div class="object" id="object_four"></div>
                  <div class="object" id="object_three"></div>
                  <div class="object" id="object_two"></div>
                  <div class="object" id="object_one"></div>
              </div>
          </div>
        </div>